import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { REVIEWS_ALL } from 'client/constants/dealer-reviews';
import { getPlural } from 'client/utils/plural';
import { SortReviewsDropdown } from 'site-modules/dealerships/components/dealer-reviews-section/components/sort-reviews-dropdown/sort-reviews-dropdown';

export function ReviewListHeader({ totalReviews, reviewsType, onSortChange = noop, withSorting = false }) {
  return (
    <>
      <div className="d-flex justify-content-between">
        <span className="size-14 text-cool-gray-30">
          {totalReviews} {reviewsType === REVIEWS_ALL ? '' : reviewsType} {getPlural('review', totalReviews)}
        </span>
        {withSorting && <SortReviewsDropdown totalReviews={totalReviews} onSortChange={onSortChange} />}
      </div>
      <hr className="mb-0 mt-0_5" />
    </>
  );
}

ReviewListHeader.propTypes = {
  totalReviews: PropTypes.number.isRequired,
  reviewsType: PropTypes.string.isRequired,
  onSortChange: PropTypes.func,
  withSorting: PropTypes.bool,
};
